<template>
    <div class="setup__steps">
        <div v-for="(s, i) in steps" class="setup__step"
            :class="{ done: i < currentIndex, locked: i > currentIndex }">
            <div class="step__progress">
                <div class="progress__icon">
                    <img src="static/img/icons/checkmark.svg" v-if="i < currentIndex"
                        alt="checkmark" />
                    <p>{{ i + 1 }}</p>
                </div>
                <div class="progress__stepper"></div>
            </div>

            <div class="step__info">
                <h5>{{ s.title }}</h5>
                <p>{{ s.subtitle }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import i18n from '../../languages';
import {
    GET_INSTALLATION_PLACED,
    GET_INSTALLATION_PROGRESS
} from '../../store/modules/proposal_progress';

@Component
export default class SetupSteps extends Vue {
    name = 'setup-steps';

    get steps() {
        return i18n.t('menu.steps');
    }

    get installationProgress() {
        return this.$store.getters[GET_INSTALLATION_PROGRESS];
    }

    get currentIndex() {
        if (this.$store.getters[GET_INSTALLATION_PLACED]) return 3;

        if (this.installationProgress.requested.completed) return 1;
        if (this.installationProgress.signed.completed) return 0;
    }
}
</script>



// WEBPACK FOOTER //
// src/components/general/SetupSteps.vue